import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Prestations from "@/pages/Prestations";
import Mariage from "@/pages/Mariage";
import Anniversaire from "@/pages/Anniversaire";
import Entreprises from "@/pages/Entreprises";
import BarRestaurant from "@/pages/BarRestaurant";
import Collectivites from "@/pages/Collectivites";
import Seniors from "@/pages/Seniors";
import Photobooth from "@/pages/Photobooth";
import LivreOr from "@/pages/LivreOr";
import Location from "@/pages/Location";
import LocationItem from "@/pages/LocationItem";
import LocationDeposit from "@/pages/LocationDeposit";
import PayAcompte from "@/pages/PayAcompte";
import JeuxAnimations from "@/pages/espace-client/JeuxAnimations";
import AdminLocation from "@/pages/admin/location/AdminLocation";
import AdminRentalDetail from "@/pages/admin/location/AdminRentalDetail";
import ConditionSheet from "@/pages/admin/location/ConditionSheet";
import { AdminGames, AdminGameEvent } from "@/pages/admin/games/AdminGames";
import PhotoVideo from "@/pages/PhotoVideo";
import MusiciensLive from "@/pages/MusiciensLive";
import BlindTestKaraoke from "@/pages/BlindTestKaraoke";
import Associations from "@/pages/Associations";
import BaptemesCommunions from "@/pages/BaptemesCommunions";
import MaxenceBerche from "@/pages/MaxenceBerche";
import Galerie from "@/pages/Galerie";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import BetaFeedback from "@/pages/BetaFeedback";
import MentionsLegales from "@/pages/MentionsLegales";
import PolitiqueConfidentialite from "@/pages/PolitiqueConfidentialite";
import NotFound from "@/pages/NotFound";

import Connexion from "@/pages/Connexion";
import Inscription from "@/pages/Inscription";
import Onboarding from "@/pages/Onboarding";
import EspaceClientLayout from "@/pages/espace-client/EspaceClientLayout";
import Dashboard from "@/pages/espace-client/Dashboard";
import Profil from "@/pages/espace-client/Profil";
import Playlist from "@/pages/espace-client/Playlist";
import Questionnaire from "@/pages/espace-client/Questionnaire";
import QuestionnairePrep from "@/pages/espace-client/QuestionnairePrep";
import PhotoboothBrief from "@/pages/espace-client/PhotoboothBrief";
import Planning from "@/pages/espace-client/Planning";
import RDV from "@/pages/espace-client/RDV";
import Commandes from "@/pages/espace-client/Commandes";
import Contrat from "@/pages/espace-client/Contrat";
import MesDocuments from "@/pages/espace-client/MesDocuments";
import AcompteConfirmation from "@/pages/espace-client/AcompteConfirmation";
import Echeances from "@/pages/espace-client/Echeances";
import Validations from "@/pages/espace-client/Validations";
import Notifications from "@/pages/espace-client/Notifications";
import SignatureDevis from "@/pages/SignatureDevis";
import PublicGallery from "@/pages/PublicGallery";

import AdminLayout from "@/pages/admin/AdminLayout";
import MyAdminLayout from "@/pages/myadmin/MyAdminLayout";
import MyAdminDashboard from "@/pages/myadmin/MyAdminDashboard";
import MyAdminEvents from "@/pages/myadmin/MyAdminEvents";
import MyAdminEventDetail from "@/pages/myadmin/MyAdminEventDetail";
import MyAdminClients from "@/pages/myadmin/MyAdminClients";
import MyAdminClientDetail from "@/pages/myadmin/MyAdminClientDetail";
import MyAdminPlans from "@/pages/myadmin/MyAdminPlans";
import MyAdminPayments from "@/pages/myadmin/MyAdminPayments";
import MyAdminSubscriptionSuccess from "@/pages/myadmin/MyAdminSubscriptionSuccess";
import MyEventDashboard from "@/pages/myevent/MyEventDashboard";
import MyEventPlanning from "@/pages/myevent/MyEventPlanning";
import MyEventGuests from "@/pages/myevent/MyEventGuests";
import MyEventPro from "@/pages/myevent/MyEventPro";
import MyEventMemories from "@/pages/myevent/MyEventMemories";
import MyEventWallet from "@/pages/myevent/MyEventWallet";
import MyEventMusic from "@/pages/myevent/MyEventMusic";
import MyEventAssistant from "@/pages/myevent/MyEventAssistant";
import MyEventLive from "@/pages/myevent/MyEventLive";
import GuestRsvp from "@/pages/public/GuestRsvp";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminClients from "@/pages/admin/AdminClients";
import AdminClientDetail from "@/pages/admin/AdminClientDetail";
import AdminCalendar from "@/pages/admin/AdminCalendar";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminBlogEditor from "@/pages/admin/AdminBlogEditor";
import AdminSEO from "@/pages/admin/AdminSEO";
import AdminAvis from "@/pages/admin/AdminAvis";
import AdminDevis from "@/pages/admin/AdminDevis";
import AdminDevisEditor from "@/pages/admin/AdminDevisEditor";
import AdminQuotes from "@/pages/admin/AdminQuotes";
import AdminCatalog from "@/pages/admin/AdminCatalog";
import AdminAccounting from "@/pages/admin/AdminAccounting";
import AdminLivreRecettes from "@/pages/admin/AdminLivreRecettes";
import AdminBilletterie from "@/pages/admin/AdminBilletterie";
import AdminBilletterieEditor from "@/pages/admin/AdminBilletterieEditor";
import AdminBilletterieDetail from "@/pages/admin/AdminBilletterieDetail";
import AdminBilletterieScan from "@/pages/admin/AdminBilletterieScan";
import AdminBilletterieScans from "@/pages/admin/AdminBilletterieScans";
import AdminPhotoboothGallery from "@/pages/admin/AdminPhotoboothGallery";
import AdminPrestataires from "@/pages/admin/AdminPrestataires";
import AdminValidations from "@/pages/admin/AdminValidations";
import AdminRDV from "@/pages/admin/AdminRDV";
import AdminPushBroadcast from "@/pages/admin/AdminPushBroadcast";

import BilletterieList from "@/pages/BilletterieList";
import BilletterieEvent from "@/pages/BilletterieEvent";
import BilletterieConfirmation from "@/pages/BilletterieConfirmation";
import BilletPublic from "@/pages/BilletPublic";
import QuizPlay from "@/pages/QuizPlay";
import AdminQuizLive from "@/pages/admin/games/AdminQuizLive";

import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Avis from "@/pages/Avis";
import LaisserAvis from "@/pages/espace-client/LaisserAvis";
import DjMariageVille from "@/pages/DjMariageVille";
import LocalServicePage from "@/pages/LocalServicePage";
import { CITIES, SERVICE_CITIES } from "@/data/cities";
import { SERVICES } from "@/data/services";
import CookieConsent from "@/components/CookieConsent";
import { initAnalytics, trackPageView } from "@/lib/analytics";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function AnalyticsRouterListener() {
  const location = useLocation();
  useEffect(() => {
    initAnalytics();
  }, []);
  useEffect(() => {
    // Envoi manuel du page_view après changement de route.
    // Méthode robuste : on écoute la mise à jour de <title> par useSeo()
    // via un MutationObserver, avec un fallback max de 400ms si aucun
    // changement n'est détecté (ex: route sans useSeo).
    let sent = false;
    let cleanupObserver = () => {};
    const send = () => {
      if (sent) return;
      sent = true;
      cleanupObserver();
      trackPageView({
        path: location.pathname + location.search,
        title: document.title,
      });
    };
    const titleEl = document.querySelector("title");
    if (titleEl && "MutationObserver" in window) {
      const observer = new MutationObserver(send);
      observer.observe(titleEl, { childList: true, subtree: true, characterData: true });
      cleanupObserver = () => observer.disconnect();
    }
    // Fallback : envoi après 400ms si le title n'a pas changé (route sans useSeo)
    const fallback = setTimeout(send, 400);
    return () => { clearTimeout(fallback); cleanupObserver(); };
  }, [location.pathname, location.search]);
  return null;
}

// Sprint 3 : redirection transparente /myadmin/* → /admin/* — préserve query & hash.
// Mapping :
//   /myadmin              → /admin (Overview Legacy — landing par défaut)
//   /myadmin/dashboard    → /admin (idem)
//   /myadmin/clients      → /admin/clients        (fiche client unifiée Sprint 2)
//   /myadmin/clients/:id  → /admin/clients/:id
//   /myadmin/events       → /admin/events         (Sprint 1)
//   /myadmin/events/:id   → /admin/events/:id
//   /myadmin/plans        → /admin/plans          (Sprint 1)
//   /myadmin/payments     → /admin/payments       (Sprint 1)
//   /myadmin/subscription/success → /admin/subscription/success
function MyadminRedirect() {
  const location = useLocation();
  const rest = location.pathname.replace(/^\/myadmin/, "") || "";
  // Alias legacy : /myadmin/dashboard → /admin (Overview)
  const target = rest === "/dashboard"
    ? `/admin${location.search || ""}${location.hash || ""}`
    : `/admin${rest}${location.search || ""}${location.hash || ""}`;
  return <Navigate to={target} replace />;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AnalyticsRouterListener />
        <CookieConsent />
        <Routes>
          {/* Public site */}
          <Route path="/jeu/:code" element={<QuizPlay />} />
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/prestations" element={<Prestations />} />
            <Route path="/mariage" element={<Mariage />} />
            <Route path="/anniversaire" element={<Anniversaire />} />
            <Route path="/entreprises" element={<Entreprises />} />
            <Route path="/dj-bar-restaurant-lille" element={<BarRestaurant />} />
            <Route path="/collectivites" element={<Collectivites />} />
            <Route path="/seniors" element={<Seniors />} />
            <Route path="/photobooth" element={<Photobooth />} />
            <Route path="/prestations/livre-d-or" element={<LivreOr />} />
            <Route path="/location" element={<Location />} />
            <Route path="/location/caution/:token" element={<LocationDeposit />} />
            <Route path="/paiement-acompte/:token" element={<PayAcompte />} />
            <Route path="/location/:slug" element={<LocationItem />} />
            <Route path="/photo-video" element={<PhotoVideo />} />
            <Route path="/musiciens-live" element={<MusiciensLive />} />
            <Route path="/blind-test-karaoke" element={<BlindTestKaraoke />} />
            <Route path="/associations" element={<Associations />} />
            <Route path="/baptemes-communions" element={<BaptemesCommunions />} />
            <Route path="/maxence-berche" element={<MaxenceBerche />} />
            <Route path="/galerie" element={<Galerie />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/beta-feedback" element={<BetaFeedback />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/avis" element={<Avis />} />
            <Route path="/billetterie" element={<BilletterieList />} />
            <Route path="/billetterie/:slug" element={<BilletterieEvent />} />
            <Route path="/billetterie/:slug/confirmation" element={<BilletterieConfirmation />} />
            <Route path="/billet/:code" element={<BilletPublic />} />
            {/* SEO local — pages non listées dans la navigation, indexées par Google */}
            {CITIES.map((c) => (
              <Route key={`mariage-${c.slug}`} path={`/dj-mariage-${c.slug}`} element={<DjMariageVille citySlug={c.slug} />} />
            ))}
            {Object.values(SERVICES).flatMap((s) =>
              SERVICE_CITIES.map((c) => (
                <Route
                  key={`${s.slug}-${c.slug}`}
                  path={`/${s.url_prefix}-${c.slug}`}
                  element={<LocalServicePage serviceSlug={s.slug} citySlug={c.slug} />}
                />
              ))
            )}
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />

            {/* ============================================================
                Legacy WordPress redirects (site IONOS supprimé, mai 2026).
                Redirections permanentes vers les pages équivalentes de la
                nouvelle webapp. Match trailing slash via /* wildcard.
                ============================================================ */}
            <Route path="/mariage-premium-test" element={<Navigate to="/mariage" replace />} />
            <Route path="/mariage-premium-test/*" element={<Navigate to="/mariage" replace />} />
            <Route path="/anniversaire-luxe" element={<Navigate to="/anniversaire" replace />} />
            <Route path="/anniversaire-luxe/*" element={<Navigate to="/anniversaire" replace />} />
            <Route path="/soirees-dentreprise" element={<Navigate to="/entreprises" replace />} />
            <Route path="/soirees-dentreprise/*" element={<Navigate to="/entreprises" replace />} />
            <Route path="/ehpad" element={<Navigate to="/seniors" replace />} />
            <Route path="/ehpad/*" element={<Navigate to="/seniors" replace />} />
            <Route path="/contact-dj" element={<Navigate to="/contact" replace />} />
            <Route path="/contact-dj/*" element={<Navigate to="/contact" replace />} />
            <Route path="/nos-partenaires" element={<Navigate to="/prestations" replace />} />
            <Route path="/nos-partenaires/*" element={<Navigate to="/prestations" replace />} />
            {/* Note : /collectivites/, /associations/, /baptemes-communions/, /galerie/
                sont déjà servies directement par React Router (v7 normalise le trailing slash).
                Aucune règle Navigate self-referencing pour éviter toute boucle. */}
          </Route>

          {/* Auth */}
          <Route path="/connexion" element={<Connexion />} />
          <Route path="/inscription" element={<Inscription />} />

          {/* Onboarding MyEvent (nouveau client sans événement) */}
          <Route path="/onboarding-myevent" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />

          {/* Espace client (protégé) */}
          <Route path="/espace-client" element={<ProtectedRoute><EspaceClientLayout /></ProtectedRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="profil" element={<Profil />} />
            <Route path="playlist" element={<Playlist />} />
            <Route path="questionnaire" element={<Questionnaire />} />
            <Route path="questionnaire-prep" element={<QuestionnairePrep />} />
            <Route path="photobooth" element={<PhotoboothBrief />} />
            <Route path="planning" element={<Planning />} />
            <Route path="rdv" element={<RDV />} />
            <Route path="commandes" element={<Commandes />} />
            <Route path="contrat" element={<Contrat />} />
            <Route path="documents" element={<MesDocuments />} />
            <Route path="documents/acompte/confirmation" element={<AcompteConfirmation />} />
            <Route path="echeances" element={<Echeances />} />
            <Route path="validations" element={<Validations />} />
            <Route path="jeux" element={<JeuxAnimations />} />
            <Route path="jeux/:id" element={<JeuxAnimations />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="avis" element={<LaisserAvis />} />
          </Route>

          {/* Public signature page (no auth, token-based) */}
          <Route path="/signature/:token" element={<SignatureDevis />} />
          {/* Public photobooth gallery (no auth, code-based) */}
          <Route path="/galerie/:code" element={<PublicGallery />} />
          <Route path="/mes-photos" element={<PublicGallery />} />

          {/* Admin (protégé + role admin) */}
          <Route path="/admin" element={<ProtectedRoute adminOnly><AdminLayout /></ProtectedRoute>}>
            <Route index element={<AdminOverview />} />
            <Route path="clients" element={<AdminClients />} />
            <Route path="clients/:id" element={<AdminClientDetail />} />
            <Route path="calendrier" element={<AdminCalendar />} />
            <Route path="blog" element={<AdminBlog />} />
            <Route path="blog/nouveau" element={<AdminBlogEditor />} />
            <Route path="blog/:id" element={<AdminBlogEditor />} />
            <Route path="seo" element={<AdminSEO />} />
            <Route path="avis" element={<AdminAvis />} />
            <Route path="devis" element={<AdminDevis />} />
            <Route path="demandes-devis" element={<AdminQuotes />} />
            <Route path="devis/nouveau" element={<AdminDevisEditor />} />
            <Route path="devis/:id" element={<AdminDevisEditor />} />
            <Route path="location" element={<AdminLocation />} />
            <Route path="location/dossiers/:id" element={<AdminRentalDetail />} />
            <Route path="location/dossiers/:id/etat/:kind" element={<ConditionSheet />} />
            <Route path="location/:tab" element={<AdminLocation />} />
            <Route path="jeux" element={<AdminGames />} />
            <Route path="jeux/:id" element={<AdminGameEvent />} />
            <Route path="jeux/:id/live" element={<AdminQuizLive />} />
            <Route path="catalogue" element={<AdminCatalog />} />
            <Route path="comptabilite" element={<AdminAccounting />} />
            <Route path="livre-recettes" element={<AdminLivreRecettes />} />
            <Route path="billetterie" element={<AdminBilletterie />} />
            <Route path="billetterie/nouveau" element={<AdminBilletterieEditor />} />
            <Route path="billetterie/scan" element={<AdminBilletterieScan />} />
            <Route path="billetterie/:id" element={<AdminBilletterieDetail />} />
            <Route path="billetterie/:id/scans" element={<AdminBilletterieScans />} />
            <Route path="billetterie/:id/edit" element={<AdminBilletterieEditor />} />
            <Route path="photobooth" element={<AdminPhotoboothGallery />} />
            <Route path="prestataires" element={<AdminPrestataires />} />
            <Route path="validations" element={<AdminValidations />} />
            <Route path="rdv" element={<AdminRDV />} />
            <Route path="notifications" element={<AdminPushBroadcast />} />

            {/* ═══ SaaS MyEvent (fusion Admin ↔ MyAdmin — Sprint 1) ═══
                Les composants MyAdmin* sont réutilisés tels quels — pas de duplication.
                Les routes /myadmin/* restent actives temporairement pour rollback. */}
            <Route path="dashboard-next" element={<MyAdminDashboard />} />
            <Route path="events" element={<MyAdminEvents />} />
            <Route path="events/:eventId" element={<MyAdminEventDetail />} />
            <Route path="plans" element={<MyAdminPlans />} />
            <Route path="payments" element={<MyAdminPayments />} />
            <Route path="subscription/success" element={<MyAdminSubscriptionSuccess />} />
          </Route>

          {/* MyAdmin NEXT — redirections vers /admin (Sprint 3)
              Le code MyAdmin* est CONSERVÉ (fichiers, composants) pour rollback rapide.
              Les composants sont désormais montés sous /admin/* (voir plus haut). */}
          <Route path="/myadmin" element={<MyadminRedirect />} />
          <Route path="/myadmin/*" element={<MyadminRedirect />} />

          {/* MyEvent NEXT (client dashboard) — protégé, RBAC event-based */}
          <Route path="/myevent/:eventId" element={<ProtectedRoute><MyEventDashboard /></ProtectedRoute>} />
          <Route path="/myevent/:eventId/planning" element={<ProtectedRoute><MyEventPlanning /></ProtectedRoute>} />
          <Route path="/myevent/:eventId/guests" element={<ProtectedRoute><MyEventGuests /></ProtectedRoute>} />
          <Route path="/myevent/:eventId/pro" element={<ProtectedRoute><MyEventPro /></ProtectedRoute>} />
          <Route path="/myevent/:eventId/memories" element={<ProtectedRoute><MyEventMemories /></ProtectedRoute>} />
          <Route path="/myevent/:eventId/wallet" element={<ProtectedRoute><MyEventWallet /></ProtectedRoute>} />
          <Route path="/myevent/:eventId/music" element={<ProtectedRoute><MyEventMusic /></ProtectedRoute>} />
          <Route path="/myevent/:eventId/assistant" element={<ProtectedRoute><MyEventAssistant /></ProtectedRoute>} />
          <Route path="/myevent/:eventId/live" element={<ProtectedRoute><MyEventLive /></ProtectedRoute>} />
          <Route path="/guest/rsvp/:token" element={<GuestRsvp />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#0a0a0a",
              border: "1px solid rgba(220,180,87,0.35)",
              color: "#fafafa",
              borderRadius: "2px",
            },
          }}
        />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
